<template>
  <div :class="[$style.container, levelClass]">
    <Component
      :is="logoIcon"
      :class="$style.imgIcon"
    />
    <div :class="$style.message">
      <slot />
    </div>
  </div>
</template>

<script>
import Constants from 'client/util/Constants';
import criticalIcon from 'public/img/icons/critical.svg?inline';
import infoIcon from 'public/img/icons/icon-info.svg?inline';
import warningIcon from 'public/img/icons/warning.svg?inline';

const { info, error, warn } = Constants;

export default {
  name: 'MessageContainer',

  props: {
    level: {
      type: String,
      validator: value => [error, info, warn].includes(value),
      default: error,
    },
  },

  computed: {
    levelClass() {
      switch (this.level) {
        case info:
          return this.$style.information;
        case warn:
          return this.$style.warning;
        case error:
        default:
          return this.$style.error;
      }
    },

    logoIcon() {
      switch (this.level) {
        case info:
          return infoIcon;
        case warn:
          return warningIcon;
        case error:
        default:
          return criticalIcon;
      }
    },
  },
};
</script>

<style module>
.container {
  border: 2px solid;
  border-radius: 2px;
  display: grid;
  font-size: 15px;
  grid-template-columns: auto 1fr;
  margin-bottom: 20px;
  padding: 10px 0;
}

.error {
  background-color: var(--jcError50);
  border-color: var(--jcError);
}

.information {
  background-color: var(--jcInformational100);
  border-color: var(--jc-color-informational-base);
}

.warning {
  background-color: var(--jcWarning100);
  border-color: var(--jcWarning);
}

.imgIcon {
  margin-left: 10px;
  width: 18px;
}

.error .imgIcon path {
  fill: jcError;
}

.warning .imgIcon path {
  fill: jcWarning;
}

.message.message {
  flex: 1;
  margin: 0;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
